import { render } from "./student-notifications.vue?vue&type=template&id=2aad2edc"
import script from "./student-notifications.vue?vue&type=script&lang=js"
export * from "./student-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__